/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-west-2",
    "aws_cognito_identity_pool_id": "us-west-2:daf58921-9e10-425d-88d6-64ef27838109",
    "aws_cognito_region": "us-west-2",
    "aws_user_pools_id": "us-west-2_voGMLIdCW",
    "aws_user_pools_web_client_id": "6i85uritufm5v28aqk8uq4scj2",
    "oauth": {
        "domain": "lolagroups-prod.auth.us-west-2.amazoncognito.com",
        "scope": [
            "phone",
            "email",
            "openid",
            "profile",
            "aws.cognito.signin.user.admin"
        ],
        "redirectSignIn": "https://app.lolagroups.com/login/success/,http://localhost:8080/login/success/",
        "redirectSignOut": "https://app.lolagroups.com/login/,http://localhost:8080/login/",
        "responseType": "code"
    },
    "federationTarget": "COGNITO_USER_POOLS",
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [
        "FACEBOOK",
        "GOOGLE"
    ],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "tornos-app-assetsprod-prod",
    "aws_user_files_s3_bucket_region": "us-west-2"
};


export default awsmobile;
